<template>
  <v-app>
    <transition name="fade">
      <router-view />
    </transition>
    <notifications class="pt-5" group="foo" classes="notification" />
    <v-overlay :value="getOverlay" z-index="99999">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <template>
      <v-dialog
        v-model="this.isAuthenticated !== 'true'"
        persistent
        max-width="400px"
      >
        <v-card class="text-center py-8">
          <h5>Session Timeout</h5>
          <span>กรุณา login ใหม่อีกครั้ง</span>
          <br />
          <v-btn
            class="mt-4 white--text"
            color="var(--primary-color)"
            elevation="2"
            style="border-radius: 20px 20px 20px 0"
            @click="handleLoginSSO"
          >
            OK
          </v-btn>
        </v-card>
      </v-dialog>
    </template>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'

export default {
  name: 'App',
  computed: {
    ...mapGetters({
      getOverlay: 'getOverlay',
      isAuthenticated: 'login/getIsAuthenticated'
    })
  },
  async mounted() {
    const params = new URLSearchParams(window.location.search)
    const businessId =
      params.get('business_id') || sessionStorage.getItem('businessId')

    if (businessId) {
      sessionStorage.setItem('businessId', businessId)
      await this.getShopProfile(businessId)
    }

    const type = params.get('type')
    const tid = params.get('tid')

    if (type && type === '2C2P' && tid) {
      var response = await this.$store.dispatch(
        'packagePlan/verifyPurchasePackage',
        { tid }
      )

      const isSuccess = response.data.result.transaction_status === 'success'

      params.delete('type')
      params.delete('ref')
      params.delete('tid')
      params.delete('paymentResponse')

      const queryString = params.toString()
      const newUrl = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname

      window.history.replaceState({}, '', newUrl)

      await this.$fire({
        title: isSuccess
          ? this.$t('purchase_package.payment_success')
          : this.$t(
              response.data.result.transaction_status === 'pending'
                ? `${response.data.result.transaction_status}_payment`
                : response.data.result.transaction_status
            ),
        type: isSuccess ? 'success' : 'error',
        reverseButtons: true,
        showCancelButton: false,
        confirmButtonText: this.$t('OK')
      })
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    async getShopProfile(businessId) {
      this.$store.dispatch('setOverlay', true)
      try {
        await Promise.all([
          this.$store.dispatch('login/getShopProfile', businessId),
          this.$store.dispatch('ssoAccount/getMemberRolePermission', businessId)
        ])
      } finally {
        this.$store.dispatch('setOverlay', false)
      }
    },
    handleLoginSSO() {
      const returnUrl = encodeURIComponent(window.location.href)
      const url = `${config.ssoUrl}/login?return_url=${returnUrl}`
      window.open(url, '_self')
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Kanit:wght@100;200;300;400;500;600;700;800;900&display=swap');
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css');
@import './App.scss';
</style>
